import React from 'react';

const ExlamationTriangle = () => {
  return (
    <svg
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
    >
      <rect
        y="0.375"
        width="16.9"
        height="14.3"
        fill="url(#pattern0_17967_20167)"
      />
      <defs>
        <pattern
          id="pattern0_17967_20167"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_17967_20167"
            transform="matrix(0.0116279 0 0 0.0135135 -0.0813954 -0.162162)"
          />
        </pattern>
        <image
          id="image0_17967_20167"
          width="100"
          height="100"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEtklEQVR4nO2cS2hUVxjHr10Uu+lC6Fa7KRQpdne/76g0MYKPkgzEx0IF3UtcJOlGF+2i0AqCiJQulBZKqWIENaC4EXSjc76QSDiNkqIQa2mhD7TQgs/0lDPUOs6DzNx7Hvfc+f7wh2FmMpwzP+5lfvecmyThcDgcDofD4XA4HA6Hw+FwOM4zvW7dSpmmOwhgnADGqgDbzXP81XvOlBBrJcBlibhIiLq+5jnzmnkPg3EcnSSvScRPCOB5I4imAjwz7zV/w2AcRSJ+uSSIZjBfMBAXMITY1TWMF6cxIXYxFIu5gbiCAH7NDATxj5vr17/FUCyFEL/OCqPu1PUVA7EBQ4gPJOI/eYGYz5BpOsBQcmRu9erXCfF27qPjJZQfrvb1LWcoGSPNT1xLMOqgfMxAMqQK8A4BPLIOBODxtBDvMpRujw6AK7Zh1EG5ppNkGUPpMIS4zxWMulPXXgbiwTmocyDsJt6cAzssu4kf56DOjxJ2E1/OQZ1DYTex5RwzAwP6l0OH9F8nTtT688GDembDhixQ2E3yOsfsli36yalTWl+69EqfnD6tZzdv7g4Iu0l+5/jz+PEmGC/68Nix7o8SdpPszjHT36/1xYttgZjXpvv6spy6ettNsjqHGhpqD+O/qsHBLEB6202yOoeqVJYGUql0/bk97SZ5nEM5BNKTbpLXOZTLI6QX3STvOodyDKSn3MTGOofyAaRX3MTGOofyAKQn1k1srXMoT0BK7SY21zmUXyDldBOb6xzKI5BSuontdQ7lGUip3MTFOofyfYSUyU1c7K1SAYCUwk1c7a1SoYDE7iau9lapQECidhOXe6tUQCBRuonrvVUqPJC43MT13ioVGEhUbuJjb5UqAJAo3MTX3ipVACBRuIkL56ACAym0m7hyDmrR2a1blwRi9m15AVJUN3F5Pwc1dEoI/XRioi2Mp2fOaBLCy1gK6SY+7ueghi6MjLQFsrB/v9exFMpNfN3PQS16f3RUL1648D8I8/jH0VHv4yiUm3i9nwObO93fr+d3767VPA45luBu4vt+Dip4g7pJqPs5qOAN5ia+nIMirHc38ekcFGG9u4lP56BI681NQjgHRVrnbhLSOSjCOneT0M5Bbe6mmt+zp9Ysd01F6yZFdI6fxsf14uTkS1OfnNT3x8aCj8u5mxTROe4dOND2Wta9kZFyu4lM049CT4oarvY+O3u2/dXeiYnae0KP85UCjFs7OiTi78EnhMVcD+m0EuA3813mBkJCDIaeDDX05saNSwIx7wk9zsZWAT7MDwTgs9AToRb9++TJtjDMv9kIPb5WlYif5gYiEb8NPRFq0blt2/Ti+fNNMMxzc8PDwcfXsgDf5AcC8F3wiWDrfl+p6AdHj+rn587Vah772twQDAghHgk+ESxHJeLnNoAMh54IlaRTiEOl/NlLkV7XsvKz18QcaqEnRJFXIh5ObOUG4huEeCv0pCjeLsg0fTOxGZmm70uAhwWYnI6qAA/Md5e4SBVgjblQFnySGEclwPyUEO8lLmNOX+ZiowS4G3rCVNQC3DEXE73vPqkCvC3TdBMJsZMrdprv4roQq7xC4HA4HA6Hw+FwOBwOh8PhcDgcDofDSeLKv/VMDivyTddUAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>
  );
};

export default ExlamationTriangle;
